type MedlayLinkEntry = {
  KW: string[]
  PC: string
  SP?: string
}

type ResolveMedlayLinkKeyArgs = {
  medlayLinkKey: MedlayLinkEntry[]
  isMobile: boolean
  keywordCheckRirekisho: (formatData: unknown, kws: string[]) => boolean
  keywordCheckShokumukeirekisho: (formatData: unknown, kws: string[]) => boolean
  formatData: unknown
}

export type MedlayLinkUrls = {
  tabLinkUrl: string
  tabLinkUrlSp: string
}

export function useMedleyLinkResolver() {
  const resolveMedlayLinkKey = ({
    medlayLinkKey,
    isMobile,
    keywordCheckRirekisho,
    keywordCheckShokumukeirekisho,
    formatData
  }: ResolveMedlayLinkKeyArgs): MedlayLinkUrls | null => {
    for (const entry of medlayLinkKey) {
      const kws = Array.isArray(entry.KW) ? entry.KW : []
      const matched = kws.some(
        (kw) =>
          keywordCheckRirekisho(formatData, [kw]) ||
          keywordCheckShokumukeirekisho(formatData, [kw])
      )
      if (matched) {
        return {
          tabLinkUrl: entry.PC || '',
          tabLinkUrlSp: isMobile ? entry.SP || entry.PC || '' : entry.PC || ''
        }
      }
    }
    return null
  }

  return { resolveMedlayLinkKey }
}
